interface Options {
  maxFractionDigits?: number;
}

export function formatNumber(value: number) {
  return Intl.NumberFormat().format(value);
}

export function roundNumber(value: number, { maxFractionDigits = 0 }: Options = {}) {
  const decimals = Math.pow(10, maxFractionDigits);

  return Math.round(value * decimals) / decimals;
}

export function roundUp(value: number, { maxFractionDigits = 0 }: Options = {}) {
  const decimals = Math.pow(10, maxFractionDigits);

  return Math.ceil(value * decimals) / decimals;
}
